// extracted by mini-css-extract-plugin
export default {"vrmChecker":"VrmCheckerWrapper__vrmChecker-wnQ1"};